<template>
  <div class="landing-root">
    <!-- <v-app id="app"> -->
    <Header />

    <v-main
      id="main"
      class="bg-grey-lighten-3 background-gutter"
    >
      <v-container
        fluid
        class="container"
      >
        <NuxtPage />
      </v-container>
    </v-main>

    <Footer />
    <!-- </v-app> -->
  </div>
</template>

<style>
@import '~/assets/css/landing-variables.css';
</style>

<style scoped>
.landing-root {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

#main {
  flex: 1;
  background-image: url("@/assets/images/SIZEN17A_33x30a.webp");
  background-position: top center;
  background-repeat: repeat;
  /* height: 200vh; */
  /* height: 240vh; */
  padding-top: 0;

  overflow: hidden;
}

#main .container {
  padding: 0;
  margin-left: auto;
  width: 100%;
}
</style>
